import React, { Component } from 'react';
import EditableCell from '../../basicElement/EditableCell';
import TableC from '../../basicElement/TableC';
import Text from '../../basicElement/Text';

class ProjectTable extends Component {
    getRender = (merge) => {
      return (text, record) => {
            const { colSpan } = record;
            return {
                children: text,
                props: {
                    colSpan: colSpan ? merge ? colSpan : 0 : 1,
                },
            };
        }
    }
    
    getColumns = () => {
        const { data, editable } = this.props;
        const len = data.length;
        const columns = [{
            title: '序号',
            dataIndex: 'number',
            key: 'number',
            width: 60,
            render: this.getRender(true),
        },{
            title: '考核内容',
            dataIndex: 'itemName',
            key: 'itemName',
            render: this.getRender(false),
        }, {
            title: <Text asterisk={editable}>考核结果</Text>,
            dataIndex: 'chooseId',
            key: 'chooseId',
            width: 240,
            render: (text, record, index) => {
                if (index < len - 2) {
                    const { detailList } = record;
                    const examineOptions = (detailList || []).map(i => ({
                        label: i.detailName,
                        value: i.crcTeacherEvaluateDetailId,
                    }));
                    return (
                        <EditableCell
                            type="Radio"
                            editable={editable}
                            value={text}
                            config={{options: examineOptions}}
                            onChange={value => this.handleChange(value, index, 'chooseId')}
                        />
                    );
                } else {
                    return {
                        children: text,
                        props: {
                            colSpan: 0
                        }
                    };
                }
            }
        }, {
            title: '得分',
            dataIndex: 'score',
            key: 'score',
            width: 120,
            render: (text, record, index) => {
                if (index < len - 2) {
                    return text;
                } else if (index == len - 2) {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 2) {
                            total += (item.score || 0) * 1;
                        }
                    });
                    return <strong>{total}</strong>;
                } else {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 2) {
                            total += (item.score || 0) * 1;
                        }
                    });
                    total += (text || 0) * 1;
                    return <strong>{total}</strong>;
                }
            }
        }];
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.props;
        const target = data[index];
        const { detailList } = target;
        target[key] = value;
        target.score = ((detailList || []).find(i => i.crcTeacherEvaluateDetailId == value) || {}).itemScore;
        this.props.onChange(data);
    }

    render() {
        const { data } = this.props;
        return (
            <TableC
                data={data}
                columns={this.getColumns()}
                className="projectTable"
            />
        );
    }
}

export default ProjectTable;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/Component/ProjectTable.js